module.exports = __webpack_public_path__ + "static/media/loading2.22a797d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading2.png
// module id = 187
// module chunks = 0